<div>
  <img class="loader-content" [src]="getImagePath('ICONS8_LOADING_V2')" alt="loader">
</div>